import { render, staticRenderFns } from "./CollectionProductForm.vue?vue&type=template&id=0a4bd418&"
import script from "./CollectionProductForm.vue?vue&type=script&lang=js&"
export * from "./CollectionProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports